<!-- BANNER
        ================================================== -->
<section class="bg-banner py-5 py-md-24 pt-lg-7 pb-lg-7 banner-style03" id="enquiry">
    <div class="container pt-1-9 pt-sm-3 pt-md-0">
        <div class="row align-items-start position-relative z-index-1">
            <div class="col-lg-7">
                <!-- Main Slider Section -->
                <div class="client-slider-section position-relative">
                    <div class="swiper mySwiper">
                        <div class="swiper-wrapper">
                            <div class="swiper-slide">
                                <img src="/assets/images/banner/hoh/1.jpg" alt="Red Monk Wellness" loading="lazy" />
                            </div>

                            <div class="swiper-slide">
                                <img src="/assets/images/banner/tm/1.jpg" alt="Red Monk Wellness" loading="lazy" />
                            </div>

                            <div class="swiper-slide">
                                <img src="/assets/images/banner/2.jpg" alt="Red Monk Wellness" loading="lazy" />
                            </div>

                            <div class="swiper-slide">
                                <img src="/assets/images/banner/tm/2.jpg" alt="Red Monk Wellness" loading="lazy" />
                            </div>


                            <div class="swiper-slide">
                                <img src="/assets/images/banner/1.jpg" alt="Red Monk Wellness" loading="lazy" />
                            </div>

                            <div class="swiper-slide">
                                <img src="/assets/images/banner/tm/3.jpg" alt="Red Monk Wellness" loading="lazy" />
                            </div>

                            <div class="swiper-slide">
                                <img src="/assets/images/banner/3.jpg" alt="Red Monk Wellness" loading="lazy" />
                            </div>

                            <div class="swiper-slide">
                                <img src="/assets/images/banner/tm/4.jpg" alt="Red Monk Wellness" loading="lazy" />
                            </div>
                        </div>

                        <!-- Navigation Arrows -->
                        <div class="swiper-button-next"></div>
                        <div class="swiper-button-prev"></div>
                    </div>
                </div>

                <div class="banner-content text-center mt-4 mb-4 text-lg-start animated fadeInLeft">
                    <p class="mb-2 text-primary text-uppercase letter-spacing-4 d-block mb-2 font-weight-800">
                        Live Limitless! Live Full!
                    </p>
                    <h1 class="mb-0 text-shadow text-white font-weight-500 lh-1">
                        Red Monk Wellness
                    </h1>

                    <!-- <a href="#" class="btn-style2 mt-4 mb-4"
                  ><span>Schedule Consultation</span></a
                > -->
                </div>
            </div>

            <div class="col-lg-5">
                <div class="text-left right-img position-relative animated fadeInRight">
                    <div class="bg-light p-1-6 p-md-4">
                        <div class="section-title-04 mb-1-9 position-relative">
                            <!-- <span class="sm-title">Enquire Now </span> -->
                            <h2 class="display-20 display-sm-20 lh-1 mb-0">
                                Enquire for More Details
                            </h2>
                            <div class="line"></div>
                        </div>

                        <div>
                            <div id="formErrors" class="text-danger mb-2" style="display:none;"></div>
                            <div id="msgSubmit" class="text-success hidden mb-2"></div>

                            <form class="contact quform" id="enquiry-form" action="#" method="post"
                                onsubmit="return validateForm(event)">
                                <div class="quform-elements">
                                    <div class="row">
                                        <!-- Begin Text input element -->
                                        <div class="col-md-12">
                                            <div class="quform-element form-group">
                                                <div class="quform-input">
                                                    <input class="form-control" id="name" type="text" name="name"
                                                        placeholder="Your name here*" />
                                                    <span id="error-fname" class="error-message"></span>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- End Text input element -->
                                        <!-- Begin Text input element -->
                                        <div class="col-md-12">
                                            <div class="quform-element form-group">
                                                <div class="quform-input">
                                                    <input class="form-control" id="email" type="text" name="email"
                                                        placeholder="Your email here*" />
                                                    <span id="error-email" class="error-message"></span>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- End Text input element -->
                                        <!-- Begin Text input element -->
                                        <div class="col-md-12">
                                            <div class="quform-element form-group">
                                                <div class="quform-input">
                                                    <input class="form-control" id="phone" type="text" name="phone"
                                                        placeholder="Your phone here" />
                                                    <span id="error-phone" class="error-message"></span>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- End Text input element -->
                                        <!-- Begin Text input element -->
                                        <div class="col-md-12">
                                            <div class="quform-element form-group quform-select-replaced">
                                                <div class="quform-input">
                                                    <input class="form-control" id="subject" type="text" name="subject"
                                                        placeholder="Your location here*" />
                                                    <span id="error-location" class="error-message"></span>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- End Text input element -->


                                        <!-- Radio Buttons -->
                                        <!-- <div class="col-md-12">
                                                    <div class="quform-element form-group">
                                                        <label class="d-block mb-2 fw-bold">Select Service*</label>
                                                        <div class="d-flex flex-wrap gap-3">
                                                            <label class="d-flex align-items-center">
                                                                <input type="radio" name="brand"
                                                                    value="House of Hydration" class="me-2" /> House of
                                                                Hydration
                                                            </label>
                                                            <label class="d-flex align-items-center">
                                                                <input type="radio" name="brand" value="Timeless Monk"
                                                                    class="me-2" /> Timeless Monk
                                                            </label>
                                                        </div>
                                                        <span id="error-brand" class="error-message"></span>
                                                    </div>
                                                </div> -->

                                        <div class="col-md-12">
                                            <div class="quform-element form-group">
                                                <label class="d-block mb-2 fw-bold">Interested in*</label>
                                                <div class="d-flex flex-wrap gap-3">
                                                    <label class="custom-radio">
                                                        <input type="radio" name="brand" value="House of Hydration" />
                                                        <span class="radio-circle"></span>
                                                        <span class="radio-text">House of Hydration</span>
                                                    </label>
                                                    <label class="custom-radio">
                                                        <input type="radio" name="brand" value="Timeless Monk" />
                                                        <span class="radio-circle"></span>
                                                        <span class="radio-text">Timeless Monk</span>
                                                    </label>
                                                </div>
                                                <span id="error-brand" class="error-message"></span>
                                            </div>
                                        </div>


                                        <!-- Begin Textarea element -->
                                        <div class="col-md-12">
                                            <div class="quform-element form-group">
                                                <div class="quform-input">
                                                    <textarea class="form-control" id="message" name="message" rows="3"
                                                        placeholder="Your message here*"></textarea>
                                                    <span id="error-message" class="error-message"></span>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- End Textarea element -->
                                        <!-- Begin Submit button -->
                                        <div class="col-md-12">
                                            <div class="quform-submit-inner">
                                                <button class="btn-style2 border-0" type="submit" id="submitBtn">
                                                    <span id="submitText">Submit</span>
                                                    <span id="submitLoader" style="display:none;">⏳</span>
                                                </button>
                                            </div>
                                            <div class="quform-loading-wrap text-start">
                                                <span class="quform-loading"></span>
                                            </div>
                                        </div>
                                        <!-- End Submit button -->
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</section>

<!-- ABOUT
        ================================================== -->
<section class="overflow-hidden position-relative about-style-03 bg-light-yellow" id="aboutus">
    <div class="container">
        <div class="row align-items-center position-relative z-index-9">
            <div class="col-lg-4 wow fadeInUp" data-wow-delay="100ms">
                <div class="px-xxl-4 mx-xxl-3 pb-md-4 pb-lg-0">
                    <div class="about-img-box">
                        <div class="shape-line">
                            <svg viewbox="0 0 442 357">
                                <path class="shape-line"
                                    d="M220.6 3C339.98 3 437.1 100.12 437.1 219.5V351.99H440.1V219.5C440.1 160.87 417.27 105.75 375.81 64.29C334.35 22.83 279.23 0 220.6 0C161.97 0 106.85 22.83 65.39 64.29C28.67 101.01 6.57 148.46 2 199.56H5.02C15.12 89.5 107.94 3 220.6 3Z">
                                </path>
                                <path class="shape-dot"
                                    d="M7 198.5C7 200.433 5.433 202 3.5 202C1.567 202 0 200.433 0 198.5C0 196.567 1.567 195 3.5 195C5.433 195 7 196.567 7 198.5Z">
                                </path>
                                <path class="shape-dot"
                                    d="M442 353.5C442 355.433 440.433 357 438.5 357C436.567 357 435 355.433 435 353.5C435 351.567 436.567 350 438.5 350C440.433 350 442 351.567 442 353.5Z">
                                </path>
                            </svg>
                        </div>
                        <div class="text-shape">
                            <svg viewbox="0 0 408 579">
                                <path id="textboxpath"
                                    d="M0 204C0 91.3339 91.3339 0 204 0V0C316.666 0 408 91.3339 408 204V316.879V375C408 487.666 316.666 579 204 579V579C91.3339 579 0 487.666 0 375V204Z">
                                </path>
                                <text>
                                    <textpath href="#textboxpath" startoffset="840">
                                        Red Monk Wellness
                                    </textpath>
                                </text>
                            </svg>
                        </div>
                        <div class="img-1 image-hover">
                            <img src="/assets/images/aboutus.jpg" alt="..." />
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-8 wow fadeInUp" data-wow-delay="200ms">
                <div class="ps-lg-0 ps-xl-0">
                    <div class="section-title-04 mb-5 position-relative">
                        <!-- <span class="sm-title">About Us </span> -->
                        <h2 class="display-16 lh-1 mb-0">
                            About Red Monk Wellness
                        </h2>
                        <div class="line"></div>
                    </div>
                    <p class="mb-1-5">
                        IV Therapy is transforming the health and wellness landscape by offering fast, effective
                        solutions
                        tailored to a wide range of wellness and cosmetic needs.<strong> Red Monk
                            Wellness</strong>, has adopted
                        the latest advancements in scientific and medical research to bring you a variety of IV
                        therapies
                        designed to meet your unique requirements- all at your convenience and delivered
                        directly to your
                        doorstep.
                    </p>
                    <!-- <p class="mb-1-5">
                                Our IV therapies are administered and closely monitored by highly qualified doctors and
                                medical
                                professionals, ensuring your safety and well-being throughout the process. We pride
                                ourselves on being
                                quick, dependable, trustworthy, and affordable. Each therapy blend is meticulously
                                crafted by our
                                doctors, taking into account your comprehensive health reports and individual body type,
                                to provide you
                                with optimal results.
                            </p> -->


                    <div class="position-relative">
                        <a routerLink="/home" class="btn-style1"><span>Read more </span></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- <div
          class="position-absolute bottom-n5 bottom-xxl-5 right-n15 right-xxl-n5 ani-top-bottom d-none d-md-block"
        >
          <img src="img/content/shape-09.png" alt="..." />
        </div> -->
</section>

<!-- HOUSE OF HYDRATION
        ================================================== -->
<section class="bg-light-red">
    <div class="container">
        <div class="mb-1-9 mb-md-5 text-center">
            <img src="/assets/images/House-of-Hydration.png" alt="Red Monk Wellness">
            <span class="text-primary alt-font text-uppercase small letter-spacing-4 d-block mb-2 fw-bold">Covering
                the
                entire gamut of your wellness needs, first we have-
            </span>
            <h2 class="mb-0 display-16 lh-1">House Of Hydration - Our Wellness IV’s </h2>

            <p class="mt-3">
                Our holistic therapies cover the entire spectrum of wellness. Some of our popular and proven IV
                drips,
                specially curated to enhance your lifestyle and health, include the
                following:
            </p>
        </div>
        <div class="row mt-n2-2">
            <div class="col-lg-4 col-sm-6 mt-2-2">
                <div class="card card-style-11 border-color-light-black h-100">
                    <div class="icon mb-1">
                        <img src="/assets/images/icons/Combating-Fatigue.png" class="w-70px mb-1" alt="..." />
                    </div>
                    <h3 class="h4 mb-2"><a href="#">HOH RENEW </a></h3>
                    <h5 class="mb-2">Sustainable energy & reduced levels of fatigue</h5>
                    <p>This drip boosts sustainable energy, combat fatigue, and restores overall vitality,
                        helping you stay
                        active, alert, and at your best- always.
                    </p>

                </div>
            </div>

            <div class="col-lg-4 col-sm-6 mt-2-2">
                <div class="card card-style-11 border-color-light-black h-100">
                    <div class="icon mb-1">
                        <img src="/assets/images/icons/2.png" class="w-70px mb-1" alt="..." />
                    </div>
                    <h3 class="h4 mb-2"><a href="#">HOH RENAISSANCE </a></h3>
                    <h5 class="mb-2">Peak brain performance & neural vitality</h5>
                    <p>This IV drip is carefully designed to enhance focus, improve mental clarity, and support
                        optimal
                        cognitive function.

                    </p>

                </div>
            </div>


            <div class="col-lg-4 col-sm-6 mt-2-2">
                <div class="card card-style-11 border-color-light-black h-100">
                    <div class="icon mb-1">
                        <img src="/assets/images/icons/3.png" class="w-70px mb-1" alt="..." />
                    </div>
                    <h3 class="h4 mb-2"><a href="#">HOH RADIANCE</a></h3>
                    <h5 class="mb-2">Achieving the natural glow</h5>
                    <p>By optimizing nutrient levels and improving blood circulation, this drip enhances the
                        quality of hair
                        and boosts the texture, clarity & elasticity of skin from within.

                    </p>

                </div>
            </div>



        </div>
        <div class="mt-1-9 mt-md-4 text-center">
            <a href="https://houseofhydration.redmonkwellness.com/Home" class="btn-style1"><span>View All </span></a>
        </div>
    </div>
</section>


<!-- Director's Profile
        ================================================== -->

<section class="bg-light-color">
    <div class="container">

        <div class="row">
            <div class="col-lg-3 wow fadeInUp" data-wow-delay="200ms">
                <div class="card card-style-07 border-0 bg-transparent">
                    <div class="image ">
                        <a href="#"><img src="/assets/images/manadavi-s-mishra.jpg" alt="Director's Profile"
                                loading="lazy" /></a>
                    </div>
                </div>
            </div>
            <div class="col-lg-9 ps-lg-5 mt-5 mt-lg-0 wow fadeInUp" data-wow-delay="400ms">
                <div class="section-title left mb-3">
                    <span class="sm-title">Red Monk Wellness Pvt Ltd </span>
                    <h2 class="display-16 lh-1 mb-2">Mandavvi S. Mishra</h2>
                    <p class="para">Co-founder and Director</p>
                    <div class="line"></div>
                </div>
                <div class="">
                    <h5 class="mb-2">From Homemaker to Wellness Expert- The Inspiring Journey of Mandavvi S. Mishra</h5>
                    <p class="mb-2">What began as a personal pursuit of better health turned into a lifelong mission.
                        For
                        Mandavvi S. Mishra, the pursuit of wellness was born from experience, observation, and an
                        unshakable
                        belief that good health is the foundation of everything we are capable of becoming.</p>

                    <p>There was a time when balancing home, family, and her own wellbeing felt like an impossible
                        equation.
                        But instead of surrendering to routine, she began learning- reading, researching, experimenting,
                        sitting
                        down with doctors, and understanding the science behind the body’s needs. What started as
                        curiosity soon
                        evolved into expertise, and expertise became a calling.</p>
                </div>

                <div class="mb-0 pb-0 border-top border-0 wow fadeInUp" data-wow-delay="200ms">
                    <h5 class="mb-2">Founding Red Monk Wellness Pvt. Ltd.</h5>

                    <p class="mb-4">This was the very challenge that Mandavvi S. Mishra chose to embrace. She
                        launched her
                        wellness enterprise from the ground up- starting with a powerful vision but minimal resources.
                        Her
                        biggest strengths were her persistence, her family’s unwavering encouragement, and the belief of
                        her
                        doctors who knew she could not only enter the market but redefine what wellness means for modern
                        India.
                    </p>

                </div>

                <div class="mt-2 text-start">
                    <a routerLink="/mandavi-s-mishra" class="btn-style1"><span>Read More </span></a>
                </div>


            </div>



        </div>


    </div>
</section>



<!-- What is it?
        ================================================== -->
<section class="about-style-04" id="whatisit">
    <div class="container">
        <div class="row g-5 align-items-center mt-n6">
            <div class="col-lg-8 mt-6">
                <div class="ps-lg-0 ps-xl-0">
                    <div class="section-title-02 position-relative mb-1-9 mb-xl-2-9">
                        <img src="/assets/img/content/section-title.png" class="section-title-img" alt="..." />
                        <span class="sm-title">What is it? </span>
                        <h2 class="position-relative z-index-9 mb-0">
                            One solution for all your problems
                        </h2>
                    </div>
                    <p>
                        For the uninitiated, IV therapy is an innovative,
                        science-based solution designed to achieve total body
                        wellness. It is a form of medical treatment that entails the
                        delivery of fluids, vitamins, minerals and other nutrients
                        directly into the bloodstream via an intravenous drip.
                    </p>
                    <p>
                        In recent times, this industry has certainly taken the world
                        by storm! In our country, the hydration therapy market is
                        witnessing exponential growth,
                    </p>

                    <div class="position-relative">
                        <a routerLink="/home" class="btn-style1"><span>Read more </span></a>
                    </div>

                </div>
            </div>

            <div class="col-lg-4 mt-4">
                <div class="text-end position-relative img1 image-hover mb-sm-8 mb-lg-0">
                    <img src="/assets/images/what-is-it2.jpg" class="rounded" alt="..." />
                    <!-- <div class="img2 d-none d-sm-block image-hover">
                  <img src="images/what-is-it1.jpg" class="rounded" alt="..." />
                </div> -->
                </div>
            </div>
        </div>
    </div>
</section>

<!-- Timeless Monk 1================================================== -->
<section class="bg-dark">
    <div class="container">
        <div class="row g-5 align-items-center">
            <div class="col-lg-6 wow fadeInUp" data-wow-delay="100ms">
                <div>
                    <div class="section-title-02 position-relative">
                        <img src="/assets/images/Timeless-Monk-W.png" alt="Red Monk Wellness">
                        <!-- <img
                    src="img/content/section-title.png"
                    class="section-title-img"
                    alt="..."
                  /> -->

                        <h2 class="position-relative display-16 z-index-9 text-white mb-2">
                            Timeless Monk
                        </h2>

                        <span class="sm-title mb-4">Setting new benchmarks in cosmetic therapy
                        </span>
                    </div>
                    <p class="text-white mb-3">
                        Beyond the realm of wellness, the House of Hydration has also
                        ventured into the world of cosmetic IV therapy, where beauty
                        and science come together in perfect harmony. In other words,
                        skincare and self-care intertwine at the cellular level, where
                        results are far more in-depth than what over-the-counter
                        creams and supplements can ever offer.
                    </p>

                    <p class="text-white mb-3">
                        With the robust backing of advanced formulations and an expert
                        fraternity of experienced medical experts, House of Hydration
                        has brought to the table a carefully curated line of premium
                        cosmetic drips designed to bolster health, beauty and
                        performance from deep within. Each drip is more than just mere
                        therapy - it’s actually an experience specially crafted for
                        those who believe in investing in themselves.
                    </p>
                </div>

                <div class="mt-1-9 mt-md-5 text-start">
                    <a href="https://timelessmonk.redmonkwellness.com/Home" class="btn-style1"><span>View More
                        </span></a>
                </div>
            </div>

            <div class="col-lg-6 wow fadeInUp" data-wow-delay="200ms">
                <div class="text-center image-hover">
                    <img src="/assets/images/timeless-monk1.jpg" alt="..." />
                </div>
            </div>
        </div>
    </div>
</section>

<!-- Timeless Monk 2
        ================================================== -->
<section class="bg-light-yellow position-relative why-choose-01 pt-lg-5 bg-img cover-background" data-overlay-light="5"
    data-background="img/bg/bg-05.jpg">
    <div class="container">
        <div class="row g-xl-5">
            <div class="col-lg-6 mt-5 wow fadeInUp animated" data-wow-delay="100ms">
                <div class="pe-xl-0">
                    <div class="section-title-04 mb-5 position-relative">
                        <span class="sm-title">Secondly, we’re setting new benchmarks in cosmetic therapy
                        </span>
                        <h2 class="display-16 lh-1 mb-0">
                            Timeless Monk - The Cosmetic IV Collection
                        </h2>
                        <div class="line"></div>
                    </div>

                    <div id="accordion" class="accordion-style">
                        <div class="card mb-3">
                            <div class="card-header" id="headingOne">
                                <h5 class="mb-0">
                                    <button class="btn btn-link" data-bs-toggle="collapse" data-bs-target="#collapseOne"
                                        aria-expanded="true" aria-controls="collapseOne">
                                        <i class="fa fa-arrow-right"></i> Eternal Monk IV (Anti-Ageing;
                                        Longevity)
                                    </button>
                                </h5>
                            </div>

                            <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                                data-bs-parent="#accordion">
                                <div class="card-body">
                                    Eternal Monk is a revitalizing blend that supports collagen production-
                                    designed to slow down
                                    visible signs of aging, it helps skin stay firm, radiant and youthful, all
                                    the while energizing
                                    your body at the deepest level.
                                </div>
                            </div>
                        </div>

                        <div class="card mb-3">
                            <div class="card-header" id="headingTwo">
                                <h5 class="mb-0">
                                    <button class="btn btn-link collapsed" data-bs-toggle="collapse"
                                        data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                        <i class="fa fa-arrow-right"></i> Iron Monk IV (Energy, Performance;
                                        Recovery)
                                    </button>
                                </h5>
                            </div>
                            <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo"
                                data-bs-parent="#accordion">
                                <div class="card-body">
                                    For those who refuse to slow down. Iron Monk fuels strength and stamina,
                                    while it is also built
                                    for sharper focus and all-day vitality.
                                </div>
                            </div>
                        </div>

                        <div class="card mb-3">
                            <div class="card-header" id="headingThree">
                                <h5 class="mb-0">
                                    <button class="btn btn-link collapsed" data-bs-toggle="collapse"
                                        data-bs-target="#collapseThree" aria-expanded="false"
                                        aria-controls="collapseThree">
                                        <i class="fa fa-arrow-right"></i> Golden Monk IV (Skin, Glow; Beauty)
                                    </button>
                                </h5>
                            </div>
                            <div id="collapseThree" class="collapse" aria-labelledby="headingThree"
                                data-bs-parent="#accordion">
                                <div class="card-body">
                                    The Golden Monk IV is crafted to brighten skin tone, reduce dullness and
                                    give a luminous glow from
                                    within. Powered with antioxidants and skin-repairing nutrients, it supports
                                    collagen synthesis and
                                    detoxifies your system
                                </div>
                            </div>
                        </div>




                    </div>

                    <div class="position-relative mt-4">
                        <a routerLink="/timelessmonk" class="btn-style1"><span>Read more </span></a>
                    </div>

                </div>
            </div>
            <div class="col-lg-6 mt-5 wow fadeInUp animated" data-wow-delay="200ms">
                <div class="text-center why-choose-img position-relative image-hover">
                    <img src="/assets/images/The-Cosmetic-IV-Collection.jpg"
                        class="border-radius-10 z-index-9 position-relative" alt="..." />
                    <div class="why-choose-shape-1 d-none d-md-block">
                        <img src="/assets/img/content/shape-11.png" alt="..." />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="position-absolute top-n10 top-md-n20 left-n30 left-lg-n20 opacity2">
        <img src="/assets/img/icons/icon-33.png" alt="..." />
    </div>
</section>

<!-- How this therapy works============= -->
<section class="bg-img cover-background bg-secondary parallax" data-overlay-dark="0" id="howitworks"
    style="background-image: url(/assets/images/bg/bg1.jpg)">
    <div class="container">
        <div class="row">
            <div class="col-lg-7 col-xl-6 col-xxl-5 wow fadeInUp" data-wow-delay="100ms">
                <div class="working-section">
                    <div class="mb-1-6 mb-sm-1-9">
                        <h2 class="display-16 mb-0">How this therapy works</h2>
                    </div>
                    <p class="mb-1-6 mb-sm-1-9">
                        It works by bypassing the digestive system and delivering
                        nutrients directly into the bloodstream, allowing for rapid
                        absorption and utilization by the body. This method ensures
                        that nutrients are immediately available for cellular
                        function, which can be beneficial for hydration, immune
                        support, energy, and overall wellness.
                    </p>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- How this therapy works end============= -->

<!-- Benefits
        ================================================== -->
<section class="bg-light-yellow2" id="benefits">
    <div class="container">
        <div class="mb-1-9 mb-md-5 text-center">
            <span class="text-primary alt-font text-uppercase small letter-spacing-4 d-block mb-2 fw-bold">Benefits
                Galore</span>
            <h2 class="mb-0 display-16 lh-1">
                IV Drip Therapy offers a wide range of benefits, including
            </h2>
        </div>
        <div class="row mt-n2-2">
            <div class="col-lg-3 col-sm-6 mt-2-2">
                <div class="card card-style-11 border-color-light-black h-100">
                    <div class="icon mb-1">
                        <img src="/assets/images/icons/Increased-Hydration.png" class="w-70px mb-4" alt="..." />
                    </div>
                    <!-- <h3 class="h4 mb-3">
                  <a href="#">Benefits 1</a>
                </h3> -->
                    <p>Increased Hydration</p>
                </div>
            </div>

            <div class="col-lg-3 col-sm-6 mt-2-2">
                <div class="card card-style-11 border-color-light-black h-100">
                    <div class="icon mb-1">
                        <img src="/assets/images/icons/Improved-Energy-Levels.png" class="w-70px mb-4" alt="..." />
                    </div>
                    <!-- <h3 class="h4 mb-3">
                  <a href="#">Benefits 2</a>
                </h3> -->
                    <p>Improved Energy Levels</p>
                </div>
            </div>

            <div class="col-lg-3 col-sm-6 mt-2-2">
                <div class="card card-style-11 border-color-light-black h-100">
                    <div class="icon mb-1">
                        <img src="/assets/images/icons/Enhanced-Immune-Function.png" class="w-70px mb-4" alt="..." />
                    </div>
                    <!-- <h3 class="h4 mb-3">
                  <a href="#">Benefits 3</a>
                </h3> -->
                    <p>Enhanced Immune Function</p>
                </div>
            </div>

            <div class="col-lg-3 col-sm-6 mt-2-2">
                <div class="card card-style-11 border-color-light-black h-100">
                    <div class="icon mb-1">
                        <img src="/assets/images/icons/Faster-Recovery-from-any-illness-or-exercise.png"
                            class="w-70px mb-4" alt="..." />
                    </div>
                    <!-- <h3 class="h4 mb-3">
                  <a href="#">Benefits 4</a>
                </h3> -->
                    <p>Faster Recovery from any illness or exercise</p>
                </div>
            </div>


        </div>

        <div class="mt-1-9 mt-md-5 text-center">
            <p class="font-weight-600">
                The specific benefits depend on the formulation of the IV drip, as
                well as the individual’s health needs and goals.
            </p>
        </div>

        <div class="position-relative mt-4 text-center">
            <a routerLink="/home" class="btn-style1"><span>View more </span></a>
        </div>

    </div>
</section>

<!-- Frequency
        ================================================== -->
<section class="about-style-01">
    <div class="container">
        <div class="row align-items-center position-relative z-index-9 mt-n1-9">
            <div class="col-lg-6 mt-1-9">
                <div class="text-center position-relative about-left">
                    <img src="/assets/images/frequency.png" alt="..." class="position-relative z-index-9 my-8" />
                    <!-- <div class="about-sm-img d-none d-md-block">
                  <img src="img/content/shape-11.png" alt="..." />
                </div> -->
                </div>
            </div>
            <div class="col-lg-6 mt-1-9">
                <div class="ps-lg-0 ps-xl-0">
                    <div class="section-title-04 mb-5 position-relative">
                        <!-- <span class="sm-title">Get to Know Us </span> -->
                        <h2 class="display-20 display-sm-15 display-xl-9 lh-1 mb-0">
                            Frequency
                        </h2>
                        <div class="line"></div>
                    </div>
                    <p class="mb-1">
                        <strong> How often do we require IV Drip Therapy sessions?</strong>
                    </p>

                    <p class="mb-1-9">
                        This depends
                        on factors such as the individual’s health goals, current
                        health status and response to the treatment. Some individuals
                        may benefit from regular sessions for hydration or immune
                        support, while others may only require occasional therapies
                        for specific health issues. It is always advisable to consult
                        with a reputable healthcare provider to determine the most
                        appropriate treatment schedule.
                    </p>
                    <div class="row mb-1-9 mt-n4">
                        <div class="col-md-12 mt-4">
                            <h3 class="h5">
                                WE ARE A GAME-CHANGER- Customization for every individual.
                            </h3>
                            <p class="mb-0">
                                At Red Monk Wellness, we have revolutionized the wellness
                                sector by taking the ultimate step in transforming human
                                health through personalized treatment for every patient.
                            </p>
                            <p class="mb-0">
                                Our mission is simple: to educate everyone about this form
                                of vital medical treatment and help individuals lead more
                                active lifestyles, and, of course, avoid ailments.
                            </p>
                        </div>
                    </div>

                    <div class="position-relative mt-2">
                        <a routerLink="/home" class="btn-style1"><span>Read more </span></a>
                    </div>

                </div>
            </div>
        </div>
    </div>
    <!-- <div class="position-absolute top-n5 right-n20 right-xxl-n15 ani-top-bottom d-none d-xl-block">
          <img src="images/icons/iv-drip.png" alt="..." />
        </div> -->
</section>